import React, {useState, useEffect} from "react";
import {Card, Table, TableBody, TableRow, TableCell, Heading, Flex, Button, TextField} from "@aws-amplify/ui-react";
import {useLoaderData, useNavigation, useNavigate, useRevalidator} from "react-router-dom";
import moment from "moment";
import GlobalAlert from "../../components/GlobalAlert";
import styles from './index.module.css';
import Loading from "../../components/Loading";
import {FiCheckSquare, FiEdit} from 'react-icons/fi';
import {updateUserAttributes} from "../../data/api";

const userAttributesToDisplay = [
  "given_name",
  "family_name",
  "email",
];

const User = () => {
  const [updateError, setUpdateError] = useState();

  const {
    user,
    license,
    license_is_active,
    error,
  } = useLoaderData();
  const revalidator = useRevalidator();

  const {UserAttributes = {}} = user || {};

  const user_attributes = UserAttributes.reduce((acc, cur) => {
    const {
      Name,
      Value,
    } = cur || {};

    return userAttributesToDisplay.includes(Name) ?
      {
        ...acc,
        [Name]: Value,
      } :
      acc;
  }, {})

  const {
    given_name,
    family_name,
    email,
  } = user_attributes || {};

  const {
    end,
  } = license || {};

  const [inEditingFieldName, setInEditingFieldName] = useState(null);
  const [newFieldValue, setNewFieldValue] = useState(null);

  const scrolledRef = React.useRef(false);

  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById("user");
      if (element) {
        element.scrollIntoView({block: "start", inline: "nearest", behavior: 'smooth'});
        scrolledRef.current = true;
      }
    }, 100);
  }, [JSON.stringify(user)]);

  const navigate = useNavigate();
  const navigation = useNavigation();

  const getFieldValueByName = fieldName => {
    switch (fieldName) {
      case "given_name":
        return given_name;
      case "family_name":
        return family_name;
      default:
      //
    }
  }

  const getField = (fieldName) => {
    const fieldValue = getFieldValueByName(fieldName);
    if (inEditingFieldName === fieldName) {
      return (
        <Flex
          as="form"
          alignItems="center"
          justifyContent="space-between"
        >
          <TextField
            defaultValue={fieldValue}
            label=""
            isRequired
            size="small"
            id="given_name"
            variation="quiet"
            onChange={e => setNewFieldValue(e.currentTarget.value)}
          />
          <Button
            size="small"
            type="submit"
            variation="link"
            onClick={e => {
              e.preventDefault();
              saveUserAttributes(fieldName, newFieldValue)
            }}
          >
            <FiCheckSquare/>
          </Button>
        </Flex>
      );
    } else {
      return (
        <Flex
          alignItems="center"
          justifyContent="space-between"
        >
          {fieldValue || '---'}
          {' '}
          <Button
            size="small"
            variation="link"
            onClick={() => {
              setInEditingFieldName(fieldName)
              setNewFieldValue(fieldValue)
            }}
          >
            <FiEdit/>
          </Button>
        </Flex>
      );
    }
  }

  const saveUserAttributes = (name, value) => {
    const userAttributes = [{
      "Name": name,
      "Value": value,
    }]

    updateUserAttributes(userAttributes)
      .then(res => {
        setInEditingFieldName(null);
        revalidator.revalidate();
      })
      .catch(setUpdateError)
  }

  if (navigation.state === "loading") {
    return <Loading/>
  }

  return (
    <Flex
      id="user"
      gap="1rem"
      direction="column"
      className={styles.userWrapper}
      templateColumns={{base: "1fr"}}
      justifyContent="flex-start"
      alignItems="center"
    >
      {
        !!error &&
        <GlobalAlert
          variation="error"
          heading={error.toString()}
        />
      }
      {
        !!updateError &&
        <GlobalAlert
          variation="error"
          heading={updateError.toString()}
        />
      }
      <Card
        className={styles.card}
        variation="elevated"
      >
        <Flex
          alignItems="center"
          justifyContent="space-between"
        >
          <Heading level={2}>
            Utente
          </Heading>
          <Button
            size="small"
            className={styles.changePassBtn}
            onClick={() => navigate("/utente/cambia-password")}
          >
            Cambia password
          </Button>
        </Flex>
        {
          !user ?
            <p><i>Nessun dato</i></p> :
            <Flex
              gap="1rem"
              direction="column"
              alignItems="flex-start"
              justifyContent="center"
            >
              <Table
                caption=""
                className={styles.table}
                size="small"
                variation="striped"
              >
                <TableBody>
                  <TableRow>
                    <TableCell as="th">E-mail</TableCell>
                    <TableCell>
                      {
                        email ?
                          <a href={`mailto:${email}`}>{email}</a> :
                          '---'
                      }
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell as="th">Nome</TableCell>
                    <TableCell>
                      {getField('given_name')}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell as="th">Cognome</TableCell>
                    <TableCell>
                      {getField('family_name')}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Flex>
        }
      </Card>
      <Card
        className={styles.card}
        variation="elevated"
      >
        <Heading level={2}>
          Licenza
        </Heading>
        {
          !license ?
            <p><i>Nessuna licenza</i></p> :
            (
              <Table
                caption=""
                className={styles.table}
                size="small"
                variation="striped"
              >
                <TableBody>
                  <TableRow>
                    <TableCell as="th">Stato</TableCell>
                    <TableCell>
                      {
                        license_is_active ?
                          <b className="myedu-emphasize-success">ATTIVA</b> :
                          <b className="myedu-emphasize-warning">NON ATTIVA</b>
                      }
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell as="th">Termine</TableCell>
                    <TableCell>
                      {
                        end ?
                          moment
                            .utc(end, "DD/MM/yyyy HH:mm:ss")
                            .format('DD/MM/yyyy') :
                          '---'
                      }
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            )
        }
      </Card>
    </Flex>
  )
}

export default User